export enum ProvisionalAgreement {
  NOT_REQUESTED = 'NOT_REQUESTED',
  REQUESTED = 'REQUESTED',
  NOT_GIVEN = 'NOT_GIVEN',
  GIVEN = 'GIVEN',
  UNKNOWN = 'UNKNOWN', // State for departures migrated from the old boolean provisional agreement states.
  NOT_APPLICABLE = 'NOT_APPLICABLE'
}
